import { Tag } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { tagPropsForEmployeeScore } from 'modules/performance_process/lib/employeeScoreColor'

import { SCALE } from './scales'

export const SCORE_RANGE_FILTER_IDENTIFIER = 'scoreRange'

type Option = { label: string; component: React.ReactNode; value: string }

const scoreFilter = (source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>) => {
  const options: Option[] = []
  const labels: Record<string, string> = {
    no_data: i18n.t('performance_process.analytics.datatable.filters.no_data'),
    not_meet_expectactions: i18n.t(
      'performance_process.analytics.datatable.filters.not_meet_expectactions'
    ),
    below_expectations: i18n.t(
      'performance_process.analytics.datatable.filters.below_expectations'
    ),
    meet_expectations: i18n.t('performance_process.analytics.datatable.filters.meet_expectations'),
    exceeds_expectations: i18n.t(
      'performance_process.analytics.datatable.filters.exceeds_expectations'
    ),
    outstanding: i18n.t('performance_process.analytics.datatable.filters.outstanding'),
  }

  if (!labels['no_data']) {
    throw new Error('No data label is missing')
  }

  options.push({
    label: labels['no_data'],
    component: (
      <Tag leftItem="circle" showCircle {...{ type: 'grey', solid: true }}>
        {labels.no_data}
      </Tag>
    ),
    value: '',
  })

  Object.entries(SCALE).forEach(([key, value], i) => {
    const label = labels[key]

    if (!label) throw 'Performance label is missing'

    options.push({
      label: label,
      component: (
        <Tag leftItem="circle" showCircle {...tagPropsForEmployeeScore(i + 1, 5)}>
          {label}
        </Tag>
      ),
      value: value.join('#'),
    })
  })

  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.performance'),
    path: 'scoreRange',
    identifier: SCORE_RANGE_FILTER_IDENTIFIER,
    type: FilterType.String,
    default: false,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: options,
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: SCORE_RANGE_FILTER_IDENTIFIER,
        value,
      })
    },
  })
}

export default scoreFilter
